import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const archiveAdminEventReducer = createReducer<State, Actions>(initialState, {
  [actions.archiveAdminEvent.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.archiveAdminEvent.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.archiveAdminEvent.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.archiveAdminEvent.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default archiveAdminEventReducer;
